import { Component, Input, OnInit } from '@angular/core'

import { IntakeFileUploadBaseDirective } from './file-upload-base'

@Component({
  selector: 'mmx-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: false,
})
export class FileUploadComponent
  extends IntakeFileUploadBaseDirective
  implements OnInit
{
  @Input() insurance = false
  declare isLoading: boolean
  acceptedTypes = ['image/jpg', 'image/jpeg', 'image/png']

  ngOnInit() {
    if (this.insurance) {
      this.intakeService.insuranceError.subscribe((err: string) => {
        this.error = err
      })
    }

    super.ngOnInit()
  }

  fileChangeEvent(event: any): void {
    const file = event.target.files[0]

    if (file) {
      if (file.size / 1000 / 1000 > 10) {
        this.error = 'File size should be less than 10mb'
        this.file = null
        return
      } else if (this.acceptedTypes.indexOf(file.type) < 0) {
        this.error = 'Only jpg/jpeg/png files are supported'
        this.file = null
        return
      }

      this.file = file
      this.error = ''
      this.hint = ''
      this.isLoading = true
      this.previewImageUrl = null
      this.saveImage()
    }
  }

  saveImage() {
    this.saveImageDataToIntake(this.file)
  }

  fileBoxHandler() {
    if (!this.previewImageUrl) {
      this.addFiles()
    }
  }

  checkCardSide() {
    if (this.id && this.id.match(/back/gi)) {
      return '/assets/images/id-back.png'
    }
    return '/assets/images/id-front.png'
  }
}
